import { render, staticRenderFns } from "./videoindex.vue?vue&type=template&id=4ef0970a&scoped=true"
import script from "./videoindex.vue?vue&type=script&lang=js"
export * from "./videoindex.vue?vue&type=script&lang=js"
import style0 from "./videoindex.vue?vue&type=style&index=0&id=4ef0970a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0970a",
  null
  
)

export default component.exports